<template>
  <div class="login-wrapper">
    <!-- <img
      src="@/assets/images/logo_egis.png"
      alt="EGIS"
      class="logo-egis d-none d-sm-block d-md-block d-lg-block"
    /> -->
    <div class="form-login mt-5">
      <div class="form-header">
        <img src="@/assets/images/logo_esig_p.png" alt="e-Plan" class="logo" />
      </div>
      <div class="form-body">
        <p class="d-none d-sm-block d-md-block d-lg-block text-center">
          <span style="font-size: 0.8em; color: #fff" v-if="isRecovery"
            >Digite seu e-mail para recuperar sua senha</span
          >
          <span style="font-size: 0.8em; color: #fff" v-else
            >Digite seu usuário e senha para acessar o sistema</span
          >
        </p>
        <input
          autofocus
          type="text"
          placeholder="E-MAIL"
          class="form-control"
          v-model="user.email"
        />
        <input
          v-if="!isRecovery"
          type="password"
          placeholder="SENHA"
          class="form-control mt-2"
          v-model="user.password"
          @keyup.enter="doLogin"
        />
        <button
          @click="doLogin()"
          v-if="!isRecovery"
          :disabled="loading"
          class="btn btn-primary btn-block mt-3 mb-2"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm mr-1"
          ></span>
          CONTINUAR
        </button>

        <button
          @click="doRecovery()"
          v-if="isRecovery"
          :disabled="loading"
          class="btn btn-primary btn-block mt-1 mb-4"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm mr-1"
          ></span>
          RECUPERAR SENHA
        </button>
        <div v-if="error" class="alert alert-danger mt-3 mb-0">{{ error }}</div>
      </div>
      <div class="form-footer">
        <div class="row">
          <div class="col">
            <i class="fas fa-unlock-alt mr-2"></i>
            <a
              href
              @click.prevent="
                isRecovery = !isRecovery;
                error = '';
              "
            >
              <span v-if="isRecovery">Acessar com Login</span>
              <span v-else>Esqueci minha senha</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, userKey } from "@/global";
import axios from "axios";

export default {
  name: "Login",
  data: function() {
    return {
      user: {
        email: "",
        password: "",
      },
      error: "",
      loading: false,
      isRecovery: false,
    };
  },
  methods: {
    doLogin() {
      this.loading = true;
      let url = `${baseApiUrl}/login`;
      axios
        .post(url, this.user)
        .then((res) => {
          this.loading = false;
          this.$store.commit("setUser", res.data);
          localStorage.setItem(userKey, JSON.stringify(res.data));
          this.$router.push({ path: "/home" });
        })
        .catch((err) => {
          console.log(err);
          this.error = "Usuário ou Senha Inválidos";
          this.loading = false;
        });
    },
    doRecovery() {
      if (!this.user) return;
      axios
        .post(`${baseApiUrl}/reset-password`, { email: this.user.email })
        .then(() => {
          this.$toasted.info(
            "Verifique sua caixa postal. Foi enviado um e-mail com os dados de acesso.",
            {
              duration: 4000,
              keepOnHover: true,
              className: "v-toasted-warning",
            }
          );
          this.isRecovery = false;
          this.error = "";
        });
    },
  },
};
</script>

<style>
.login-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.logo-egis {
  height: 120px;
  width: auto;
  margin: 20px;
}

.form-login {
  display: flex;
  flex-direction: column;
  align-items: center;

  align-self: center;
  display: flex;
  flex-direction: column;
  width: 420px;
  height: 100%;
}

.form-header {
  padding: 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #fff;
  text-align: center;
  width: 100%;
}

.logo {
  height: 80px;
  width: auto;
}

.form-body {
  background-color: #505050;
  padding: 40px 30px;
  width: 100%;
}
.form-footer {
  background-color: #404040;
  text-align: center;
  color: #fff;
  padding: 20px 50px;
  width: 100%;
}

.form-footer a {
  text-decoration: none;
  color: white;
}

.alert-danger {
  background-color: #c82333;
  color: white;
  border-color: #be2131;
}
</style>
